import { render, staticRenderFns } from "./viewHeader.vue?vue&type=template&id=afa40976&scoped=true"
import script from "./viewHeader.vue?vue&type=script&lang=js"
export * from "./viewHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa40976",
  null
  
)

export default component.exports